import { forwardRef } from 'react';
import type { ReactNode, PropsWithoutRef, Ref } from 'react';
import styled from 'styled-components';

import type { BaseProps, ForwardRefForwardPropsComponent } from '../../types';
import Text from '../Text';
import Flex from '../Flex';
import ShowMoreLess from '../ShowMoreLess';

export interface CommaSeparatedListProps extends BaseProps {
  /** List content. */
  items: ReactNode[];
  /** List Heading. */
  heading?: string;
  /** Ref forwarded to the wrapping element. */
  ref?: Ref<HTMLDivElement>;
}

export const StyledCommaSeparatedList = styled.div``;

export const StyledCommaSeparatedListItem = styled.li`
  display: inline;

  &:not(:last-child)::after {
    content: ', ';
  }
`;

const CommaSeparatedList: ForwardRefForwardPropsComponent<CommaSeparatedListProps> = forwardRef(
  function CommaSeparatedList(
    { items, heading }: PropsWithoutRef<CommaSeparatedListProps>,
    ref: CommaSeparatedListProps['ref']
  ) {
    return (
      <Flex
        container={{ direction: 'column', wrap: 'wrap', gap: 2 }}
        as={StyledCommaSeparatedList}
        ref={ref}
      >
        {heading && <Text variant='h3'>{heading}</Text>}
        <Flex container={{ direction: 'column', alignItems: 'start', gap: 0.25 }}>
          <ShowMoreLess lines={3}>
            <ul>
              {items.map((value, i) => (
                // eslint-disable-next-line react/no-array-index-key
                <StyledCommaSeparatedListItem key={i}>{value}</StyledCommaSeparatedListItem>
              ))}
            </ul>
          </ShowMoreLess>
        </Flex>
      </Flex>
    );
  }
);

export default CommaSeparatedList;
